import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import {
  useBankAccountTemplateQuery,
  useUpdateBankAccountTemplate,
} from "../api/queries";
import { BankAccountTemplateForm } from "../ui/BankAccountTemplateForm";

export function BankAccountTemplateEditPage() {
  const { id } = useParams({
    from: "/app/performance/bank-account-templates/$id/edit",
  });
  const nav = useNavigate({
    from: "/app/performance/bank-account-templates/$id/edit",
  });
  const templateQuery = useBankAccountTemplateQuery(id);
  const updateTemplate = useUpdateBankAccountTemplate(id);

  const template = templateQuery.data;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ແມ່ແບບບັນຊີ",
              to: "/app/performance/bank-account-templates",
            },
            { label: template?.name ?? "ແກ້ໄຂ" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ແກ້ໄຂແມ່ແບບ</h2>
          <p className="text-muted-foreground">ປັບເນື້ອຫາຂໍ້ມູນບັນຊີທະນາຄານ</p>
        </div>

        <div className="rounded-xl border bg-card px-6">
          {templateQuery.isLoading ? (
            <p className="py-8 text-muted-foreground text-sm">ກຳລັງໂຫຼດ...</p>
          ) : !template ? (
            <p className="py-8 text-muted-foreground text-sm">ບໍ່ພົບແມ່ແບບ</p>
          ) : (
            <BankAccountTemplateForm
              initialValues={{
                name: template.name,
                taxVariant: template.taxVariant,
                content: template.content,
                contentEn: template.contentEn ?? "",
                status: template.status,
                sortOrder: template.sortOrder,
                isDefault: template.isDefault,
              }}
              onSubmit={async (vals) => {
                try {
                  await updateTemplate.mutateAsync(vals);
                } catch {}
              }}
              onCancel={() =>
                nav({ to: "/app/performance/bank-account-templates" })
              }
              submitting={updateTemplate.isPending}
            />
          )}
        </div>
      </Main>
    </>
  );
}
